<template>
  <CollapseSection
    title="Observações do tomador"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="observacoes"
    @toggleSection="$emit('toggleSection')"
  >
    <div class="pb-5">
      <div class="d-flex mb-3 align-items-end justify-content-end" v-if="editable">
        <button
          @click="$bvModal.show('show-modal-observations')"
          type="button"
          class="button btn btn-outline-secondary btn-sm"
        >
          <i class="fa fa-plus mr-1"></i> Adicionar observação
        </button>
      </div>

      <div class="scrollable-table" style="max-height: 410px">
        <table class="pretty font-14 list sticky-header">
          <thead>
            <tr>
              <th style="width: 1px">Usuário</th>
              <th style="width: 1px">Data</th>
              <th>Observação</th>
              <th style="width: 1px" v-if="editable"></th>
            </tr>
          </thead>
          
          <tbody v-if="!itemsObservation.length">
              <tr><td colspan="100%">Sem cadastros.</td></tr>
          </tbody>
  
          <tbody v-if="itemsObservation.length">
            <tr v-for="observation in itemsObservation" :key="observation.id">
              <td>
                <div class="nowrap" style="text-overflow: ellipsis;max-width: 150px;overflow: hidden;"
                  title="João Silva Onofre Messias do Carmo"
                >
                  {{ observation.author }}
                </div>
              </td>
              <td>{{ observation.date != "" ? formatDateLocal(observation.date) : "- - -" }}</td>
              <td>
                {{ truncateHtmlText(observation.text, 100) }}
                <a
                  v-if="observation.text.length > 100"
                  @click="openObservationModal(observation)"
                  title="Visualizar observação completa"
                  ><i class="fa fa-eye ml-2"></i
                ></a>
              </td>
              <td class="text-right nowrap" v-if="editable">
                <a
                  @click="openObservationModal(observation)"
                  v-b-tooltip.hover
                  :title="'Ver observação'"
                  ><i class="fas fa-eye mx-1 mr-2 icon-btn"></i
                ></a>
                <a
                  @click="openModalDeleteObservation(observation)"
                  v-b-tooltip.hover
                  :title="'Excluir observação'"
                  ><i class="fas fa-times mx-1 icon-btn"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>

    <div class="modal">
      <b-modal
        id="show-modal-view"
        ref="showModalView"
        size="lg"
        class="mt-4"
        hide-footer
      >
        <template #modal-title>Visualizar observação</template>

        <div class="card card-termo-uso mb-3" v-if="observationSelected">
          <div class="row mt-4">
            <div class="col-12 col-lg-6">
              <label class="dbo-ui" for="">Usuário</label>
              <p>
                <strong>{{ observationSelected.author }}</strong>
              </p>
            </div>
            <div class="col-12 col-lg-6">
              <label class="dbo-ui" for="">Data</label>
              <p>
                <strong>{{
                  observationSelected.date != ""
                    ? formatDateLocal(observationSelected.date)
                    : "- - -"
                }}</strong>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-12">
              <label class="dbo-ui" for="">Observação completa</label>
              <div class="pre-line complete-text" v-html="observationSelected.text"></div>
            </div>
          </div>
        </div>

        <div class="row border-top py-4">
          <div class="col-12 col-lg-12 d-flex justify-content-end">
            <button @click="closeObservationModal()" class="btn btn-secondary">
              <i class="fa fa-times mr-1"></i> Fechar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="show-modal-del"
        ref="showModalDel"
        size="md"
        class="mt-4"
        hide-footer
        centered
      >
        <template #modal-title>Remover observação</template>

        <div class="card card-termo-uso mb-3" v-if="observationSelected">
          <p class="mb-4">
            Deseja remover a observação de
            <strong>{{ observationSelected.author }}</strong> cadastrada em
            <strong>{{
              observationSelected.date
                ? formatDateLocal(observationSelected.date)
                : "-"
            }}</strong
            >?
          </p>
        </div>
        <div class="row border-top py-4">
          <div class="col-12 col-lg-12 d-flex justify-content-between">
            <button
              @click="$bvModal.hide('show-modal-del')"
              class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1"
            >
              <span class="d-none d-md-inline-block"> Cancelar</span>
            </button>

            <button
              @click="removeObservation(observationSelected.id)"
              class="btn btn-primary btn-lg text-uppercase px-4"
              data-toggle="modal"
            >
              Remover
            </button>
          </div>
        </div>
      </b-modal>
    </div>

    <observations-modal @showClientData="getObservations" />
  </CollapseSection>
</template>

<script>
import { CollapseSection } from "@/components";
import { ObservationsModal } from "@/components/Client";
import dateFormatterMixin from "@/mixins/dateFormatter";
import commomsHelperMixin from "@/mixins/commomsHelper";
import economicGroupService from "@/services/economic-group";
import companyService from "@/services/company";

export default {
  components: {
    CollapseSection,
    ObservationsModal
  },
  props: {
    expanded: Boolean,
    disabled: Boolean,
    economicGroupID: String,
    editable: { type: Boolean, default: false }
  },
  mixins: [dateFormatterMixin, commomsHelperMixin],
  data: () => ({
    loading: false,
    itemsObservation: [],
    observationSelected: {},
    
  }),
  created() {
    this.resetAlert();
    if (this.expanded && this.economicGroupID) {
      this.getObservations();
    }
  },
  methods: {
    getObservations() {
      this.loading = true;
      economicGroupService
        .getEconomicGroupObservations(this.economicGroupID)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.itemsObservation = response.data;
          this.clearUploadState();
        })
        .catch(() => {
          this.showError(
            "Não foi possível visualizar os arquivos dos grupos economicos."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openObservationModal(observation) {
      this.observationSelected = observation;
      this.$refs.showModalView.show();
    },
    closeObservationModal() {
      this.observationSelected = {};
      this.$refs.showModalView.hide();
    },
    openModalDeleteObservation(observation) {
      this.resetAlert();
      this.observationSelected = observation;
      this.$refs.showModalDel.show();
    },
    removeObservation(observationId) {
      this.loading = true;
      companyService
        .deleteEconomicGroupObservation(observationId)
        .then((response) => {
          if (response.data.error) {
            return;
          }
          this.getObservations();
        })
        .catch(() => {
          this.showError("Não foi possível apagar observação.");
        })
        .finally(() => {
          this.observationSelected = {};
          this.$bvModal.hide("show-modal-del");
          this.loading = false;
        });
    },
  },
  watch: {
    expanded: function (value) {
      if (value) {
        this.resetAlert();
        this.getObservations();
      }
    },
  },
};
</script>
<style scoped>
.complete-text { overflow-y: auto; max-height: 450px; border: 1px solid #ccc; border-radius: 5px; padding: 7px 15px; }
::v-deep .complete-text p,
  ::v-deep .complete-text ol,
  ::v-deep .complete-text ul { margin-bottom: 0px; } 
::v-deep .complete-text .ql-size-small { font-size: .75em; } 
::v-deep .complete-text .ql-size-large { font-size: 1.5em; }
::v-deep .complete-text .ql-size-huge { font-size: 2.5em; }
::v-deep .complete-text .ql-indent-1:not(.ql-direction-rtl) { padding-left: 3em; }
::v-deep .complete-text .ql-indent-2:not(.ql-direction-rtl) { padding-left: 6em; }
::v-deep .complete-text .ql-indent-3:not(.ql-direction-rtl) { padding-left: 9em; }
::v-deep .complete-text .ql-align-right { text-align: right; }
::v-deep .complete-text .ql-align-center { text-align: center; }
::v-deep .complete-text blockquote { border-left: 4px solid #ccc; margin-bottom: 5px; margin-top: 5px; padding-left: 16px; }
</style>
